import { TripDetailReportModel } from './tripdetailreport.model';
import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, RequestOptionsArgs, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';
import { JQueryHelperService } from './../../shared/models/jquery-helper.service';

@Injectable()
export class TripDetilReportService {
  JQueryHelper: JQueryHelperService = new JQueryHelperService();
  constructor(private authService: AuthService, private http: Http) { }

  // public GetDriverTripDetailList(input: TripDetailReportModel): Observable<IAPIResponse> {
  //   let getDriverTripUrl = WeGoConfig.API_GET_DRIVER_BOOKING_TRIP_LIST;
  //   let queryStringtripreportModel = this.JQueryHelper.Param(input);
  //   let headers = this.authService.GetHeader();
  //   let options = new RequestOptions({ headers: headers });

  //   getDriverTripUrl = getDriverTripUrl + "?" + decodeURIComponent(queryStringtripreportModel);
  //   return this.http.get(getDriverTripUrl, options)

  //     .map(this.authService.HandleAPIResponse)
  //     .catch(this.authService.HandleAPIError);
  // }

  public GetDriverTripDetailList(input: TripDetailReportModel): Observable<IAPIResponse> {
    let body = input;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http.post(WeGoConfig.API_GET_DRIVER_BOOKING_TRIP_LIST, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetDriverVehicleList(driverHashID: string, input?: DataListModel): Observable<IAPIResponse> {
    let getVehicleUrl = WeGoConfig.API_GET_DRIVER_VEHICLE_LIST;
    
    let queryString = input ? this.authService.HandleAPIListInput(input) : null;

    if (queryString) {
      getVehicleUrl = getVehicleUrl + "?" + queryString;
      if (driverHashID)
        getVehicleUrl = getVehicleUrl + "&driverHashID=" + driverHashID;
    }
    else {
      if (driverHashID)
        getVehicleUrl = getVehicleUrl + "?driverHashID=" + driverHashID;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getVehicleUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportTripDetailReport(input: TripDetailReportModel): any {
    let queryString = "DriverHashId=" + input.driverHashId + "&VehicleHashId=" + input.vehicleHashId +
      "&StartDateTime=" + input.startDateTime + "&EndDateTime=" + input.endDateTime;
    let getInstanceUrl = WeGoConfig.API_EXPORT_TRIP_DETAIL_REPORT + "?" + queryString;
    let headers = this.authService.GetHeader('text/csv');
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getInstanceUrl, options);
  }

  public ExportTripDetailReportPDF(input: TripDetailReportModel): any {
    let queryString = "DriverHashId=" + input.driverHashId + "&VehicleHashId=" + input.vehicleHashId +
      "&StartDateTime=" + input.startDateTime + "&EndDateTime=" + input.endDateTime;
    let getInstanceUrl = WeGoConfig.API_EXPORT_TRIP_DETAIL_REPORT_PDF + "?" + queryString;
    let headers = this.authService.GetHeader('application/pdf');
    let options = new RequestOptions({ headers: headers, responseType: ResponseContentType.Blob });
    return this.http.get(getInstanceUrl, options);
  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/tripdetailreport/models/tripdetailreport.service.ts